import punk from "../images/punk.gif";
import random from "../images/randomizer.gif";
export const emptyPunk: any = {
  name: "Boba punk #XXXX",
  id: null,
  rarity: 3,
  image: punk,
  traits: [],
};

export const randomPunk: any = {
  name: "Boba punk #XXXX",
  id: null,
  rarity: 0,
  image: random,
  traits: [],
};
